import { Component, OnInit } from "@angular/core";
import { RouteInfo } from "@auth/auth.interfaces";
import { AuthenticationService } from "@auth/authentication.service";

export const ROUTES: RouteInfo[] = [
  {
    Url: "/participante/solicitud",
    Title: "Crear solicitud",
    Icon: "",
    Class: "",
  },
  { Url: "/login", Title: "Iniciar sesión", Icon: "", Class: "" },
  { Url: "/verificate", Title: "Verificate", Icon: "", Class: "" },
];

@Component({
  selector: "sidebar-cmp",
  templateUrl: "sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  menuItems = ROUTES.slice(0);

  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit() {
    this.authenticationService.userSubject.subscribe((user) => {
      this.menuItems = user && user.Menu ? user.Menu : ROUTES.slice(0);
    });
  }
}
